<template>
  <o-form-wrapper
    :form-state="formState"
    :schema="schema"
    :server-errors="_se"
    :v="$v.item"
    v-model="item"
  >
    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="client"
    >
      <o-select
        :form-state="formState"
        :items="optionOcomClientItems"
        :server-errors="_se"
        :validators="$v.item"
        add-title="Create New"
        name="client"
        :loading="optionOcomClientWorking"
        sort-field="name"
        store-name="OcomClient"
        text-field="name"
        v-bind="schema.fields.client"
        allow-add
        v-model="item.client"
        value-field="id"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <ocom-client-form
            :form-state="formState"
            :item="item"
            :server-errors="serverErrors"
            in-modal
          ></ocom-client-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="project_name"
    >
      <o-text-field
        :server-errors="_se"
        :form-state="formState"
        :validators="$v.item"
        name="project_name"
        v-bind="schema.fields.project_name"
        v-model="item.project_name"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="quote_name"
    >
      <o-text-field
        :server-errors="_se"
        :form-state="formState"
        :validators="$v.item"
        name="quote_name"
        v-bind="schema.fields.quote_name"
        v-model="item.quote_name"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="quote_type"
    >
      <o-select
        :form-state="formState"
        :items="optionCodeQuoteTypeItems"
        :server-errors="_se"
        :validators="$v.item"
        allow-add
        @input="update_quote_type"
        name="quote_type"
        :loading="optionCodeQuoteTypeWorking"
        sort-field="description"
        store-name="CodeQuoteType"
        text-field="description"
        v-bind="schema.fields.quote_type"
        v-model="item.quote_type"
        value-field="id"
        add-title="Create New"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <code-quote-type-form
            :form-state="formState"
            :item="item"
            :server-errors="serverErrors"
            in-modal
          ></code-quote-type-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="notes"
    >
      <o-textarea
        :form-state="formState"
        rows="4"
        :server-errors="_se"
        :validators="$v.item"
        name="notes"
        v-bind="schema.fields.notes"
        v-model="item.notes"
      ></o-textarea>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="status"
    >
      <o-select
        :form-state="formState"
        :items="optionCodeQuoteStatusItems"
        :loading="optionCodeQuoteStatusWorking"
        value-field="id"
        :server-errors="_se"
        :validators="$v.item"
        add-title="Create New"
        allow-add
        name="status"
        sort-field="description"
        store-name="CodeQuoteStatus"
        text-field="description"
        v-bind="schema.fields.status"
        v-model="item.status"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <code-quote-status-form
            :form-state="formState"
            :item="item"
            :server-errors="serverErrors"
            in-modal
          ></code-quote-status-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="estimated_weeks"
    >
      <o-text-field
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="estimated_weeks"
        v-bind="schema.fields.estimated_weeks"
        v-model="item.estimated_weeks"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="won_date"
    >
      <o-date-time
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        hide-time
        name="won_date"
        v-bind="schema.fields.won_date"
        v-model="item.won_date"
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="lost_date"
    >
      <o-date-time
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        hide-time
        name="lost_date"
        v-bind="schema.fields.lost_date"
        v-model="item.lost_date"
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="versions"
    >
      <ocom-quote-version-form-cards
        :form-state="formState"
        :label="schema.fields.versions.label"
        :level="level + 1"
        :server-errors="_se.versions"
        :validators="$v.item.versions"
        @download="downloadQuote"
        @reset_json="resetJson"
        v-model="item.versions"
      >
      </ocom-quote-version-form-cards>
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import moment from "moment";
import { filter_active_list } from "../../../vue-ocom/utils/active";
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";

import { default as OcomClientForm } from "../../ocom_client/components/ItemForm";
import { default as CodeQuoteTypeForm } from "../../code_quote_type/components/ItemForm";
import { default as OcomQuoteVersionFormCards } from "../../ocom_quote_version/components/ItemFormCards";
import { default as OcomQuoteOldForm } from "../../ocom_quote_old/components/ItemForm";
import { default as CodeQuoteStatusForm } from "../../code_quote_status/components/ItemForm";

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("OcomQuote"),
    CreateCodeTableFetchMixin([
      "OcomClient",
      "CodeQuoteType",
      "OcomQuoteOld",
      "CodeQuoteStatus",
    ]),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,

    OcomClientForm,
    CodeQuoteTypeForm,
    OcomQuoteVersionFormCards,
    OcomQuoteOldForm,
    CodeQuoteStatusForm,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.OcomQuote, {}),
  }),
  methods: {
    resetJson(item) {
      if (this.item.quote_type) {
        const quote_type =
          this.optionCodeQuoteTypeItemsById[this.item.quote_type];

        if (quote_type && quote_type.default_data) {
          item.data = _.cloneDeep(quote_type.default_data);
        }
      }
    },
    update_quote_type() {
      if (this.item.quote_type) {
        const quote_type =
          this.optionCodeQuoteTypeItemsById[this.item.quote_type];

        if (quote_type && quote_type.default_data) {
          const maxDisplayOrder = _.maxBy(
            this.item.versions,
            "display_order"
          ) || { display_order: 0 };

          const who = maxDisplayOrder ? "" : "Scott Warren";
          const comments = maxDisplayOrder ? "" : "Initial Version";
          const version_text = maxDisplayOrder ? "" : "1.0";

          const newVersion = {
            version: version_text,
            who: who,
            comments: comments,
            when: moment().format("YYYY-MM-DD"),
            display_order: maxDisplayOrder.display_order + 1,
            data: _.cloneDeep(quote_type.default_data),
            _closed: false,
          };

          this.item.versions.push(newVersion);
        }
      }
    },
    downloadQuote(version) {
      var vm = this;
      var fields = _.clone(version.data);
      fields.enhancement_no = this.item.id;

      fields.client = _.clone(this.optionOcomClientItemsById[this.item.client]);
      fields.project_name = this.item.project_name;

      var addendumType =
        this.optionCodeQuoteTypeItemsById[this.item.quote_type];
      fields.addendum_type = addendumType.description;
      fields.addendum_code = addendumType.code;

      fields.versions = _.map(
        _.sortBy(
          _.filter(filter_active_list(this.item.versions), function (v) {
            return v.display_order <= version.display_order;
          }),
          ["display_order", "id"]
        ),
        function (v) {
          return _.pick(v, ["when", "who", "comments", "version_number"]);
        }
      );

      fields.files = [];
      if (version.solution_file) {
        fields.files = [version.solution_file];
      }

      fields.quote.extra_functionality_hourly = parseFloat(
        fields.quote.extra_functionality_hourly
      );
      fields.quote.total_cost = parseFloat(fields.quote.total_cost);
      fields.quote.final_payment = parseFloat(fields.quote.final_payment); // Not used for Work item
      _.forEach(fields.quote.monthly_extras, function (e) {
        e.value_ex_gst = parseFloat(e.value_ex_gst);
      });
      var request = {
        fields: fields,
        type: this.item.quote_type,
      };

      var root_url = process.env.VUE_APP_ROOT_API;
      this.axios
        .post(root_url + "/ocom_project/generate_quote2/", request, {
          responseType: "arraybuffer",
        })
        .then(
          function (response, status, headers) {
            var a = document.createElement("a");
            var blob = new Blob([response.data], {
              type: response.headers["content-type"],
            });
            a.href = URL.createObjectURL(blob);
            a.download =
              vm.item.project_name +
              "- Quote " +
              version.version_number +
              ".docx";
            a.click();
          },
          function (error) {
            console.log(error, "can not get data.");
          }
        );
    },
  },
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {},
  created() {},
};
</script>
